import React, { useState } from 'react';
import { observer } from "mobx-react";
import Container from 'react-bootstrap/Container'
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import Table from 'react-bootstrap/Table'
import { FaQuestionCircle } from "react-icons/fa";

import Link from '../Link'
import MoreInfoBox from '../MoreInfoBox'
import {regionReportsTabDataStore} from '../../store/apiStores'
import { roundAndFormat } from '../../lib/strFormatting'

import './RegionSummarySectionTable.css'

export default function RegionSummarySectionTable(props) {
    return (
        <Container className="region-summary-section-table" fluid={true} borderless={true}>
            <Row className="header">
                <Col xs={12} lg={3} className="region-page-sum-questions"></Col>
                <Col xs={12} lg={3} className="region-page-sum-metric">Metric</Col>
                <Col xs={6} lg={1} className="region-page-sum-value">Value</Col>
                <Col xs={6} lg={2} className="region-page-sum-assessment">
                    Assessment <Link to={props.refLink} target="_blank"><FaQuestionCircle /></Link>
                </Col>
                <Col xs={6} lg={3} className="region-page-sum-distribution">
                    Distribution Within Area<br /><font className="small">(by population)</font>
                </Col>
            </Row>
            {props.fields.map((f, i) => {
                return (
                    <RegionSummarySectionTableRow
                        field={f.field}
                        isPercent={f.isPercent}
                        isRatio={f.isRatio}
                        stateLevelOnly={f.stateLevelOnly}
                        question={f.question}
                        metric={f.metric}
                        showPlusSigns={f.showPlusSigns}
                        value={f.value}
                        noDistribution={f.noDistribution}
                    />
                )
            })}
        </Container>
    )
}

export var RegionSummarySectionTableRow = observer((props) => {

    let getCategory = (field, assessment) => {
        for (let i in regionReportsTabDataStore.data[field + '_distributions']) {
            let cat = regionReportsTabDataStore.data[field + '_distributions'];
            if (cat.assessment == assessment) {
                return cat;
            }
        }
    }

    let getAssessmentCaption = (field, assessment, category) => {
        if (regionReportsTabDataStore.data[field + '_assessment_caption']) {
            return regionReportsTabDataStore.data[field + '_assessment_caption'];
        } else if (assessment && category) {
            return '(' + ((category.low_limit) ? (category.low_limit + ' < ') : (''))
                + ' x ' + ((category.high_limit) ? (' < ' + category.high_limit) : ('')) + ')';
        } else {
            return '';
        }
    }

    let getAssessmentColor = (field, assessment, category) => {
        if (regionReportsTabDataStore.data[field + '_assessment_color_code']) {
            return regionReportsTabDataStore.data[field + '_assessment_color_code'];
        } else if (assessment && category) {
            return category.color_code;
        } else {
            return '';
        }
    }

    let rangeStr = (cat, options) => {
        let pctSign = (options.isPercent) ? ('%') : ('')
        let lowLimitPlusSign = (cat.low_limit && cat.low_limit > 0 && props.showPlusSigns) ? '+' : '';
        let highLimitPlusSign = (cat.high_limit && cat.high_limit > 0 && props.showPlusSigns) ? '+' : '';

        if (cat.low_limit && cat.high_limit) {
            return `(${lowLimitPlusSign}${cat.low_limit}${pctSign} to ${highLimitPlusSign}${cat.high_limit}${pctSign})`
        } else if (cat.low_limit) {
            return `(> ${lowLimitPlusSign}${cat.low_limit}${pctSign})`
        } else if (cat.high_limit) {
            return `(< ${highLimitPlusSign}${cat.high_limit}${pctSign})`
        }
    }

    let getValueAndDistributionInArea = (field, options) => {
        options = options || {}
        let pctSign = (options.isPercent) ? ('%') : ('')
        let ratioSign = (options.isRatio) ? (' : 1') : ('')

        let r = {
            value: props.value,
            valueClassName: '',
            assessment: null,
            assessmentCaption: null,
            assessmentColor: null,
            category: {},
            distributions: []
        };

        if (regionReportsTabDataStore.data) {
            if (!r.value) {
                if (regionReportsTabDataStore.data[field]) {
                    r.value = (options.isRatio) ?
                    roundAndFormat((100/regionReportsTabDataStore.data[field]),
                        {showPlusSign: props.showPlusSigns}) + ratioSign + "\n" +
                        '(' + roundAndFormat(regionReportsTabDataStore.data[field],
                        {showPlusSign: props.showPlusSigns}) + pctSign + ')'
                    : roundAndFormat(regionReportsTabDataStore.data[field],
                        {showPlusSign: props.showPlusSigns}) + pctSign + ratioSign
                    r.valueClassName = 'bigbold';
                } else {
                    r.value = 'N/A';
                }
            }
            r.assessment = regionReportsTabDataStore.data[field + '_assessment'] || 'N/A';
            r.category = getCategory(field, r.assessment);
            r.assessmentCaption = getAssessmentCaption(field, r.assessment, r.category)
            r.assessmentColor = getAssessmentColor(field, r.assessment, r.category)

            // distributions
            if (!props.noDistribution) {
                let distributions = regionReportsTabDataStore.data[field + '_distributions'] || [];
                distributions = distributions.sort((a, b) => {return a.level - b.level});
                r.distributions = distributions.map((cat) => {
                    return {
                        title: cat.assessment + ' ' + rangeStr(cat, options),
                        value: roundAndFormat(cat.population_pct || 0) + '%'
                    }
                })
                console.log('distributions: ' + r.distributions.map((e)=>{return e.title}).join(', '))
            }
        }
        console.log(field + ': ' + JSON.stringify(r))
        return r;
    }

    let fieldData = getValueAndDistributionInArea(props.field,
        {isPercent: props.isPercent, isRatio: props.isRatio});

    return (
        <Row>
            <Col xs={12} lg={3} className="cell region-page-sum-questions">{props.question}</Col>
            <Col xs={12} lg={3} className="cell region-page-sum-metric">{props.metric}</Col>
            <Col xs={6} lg={1} className="cell region-page-sum-value" style={{backgroundColor: fieldData.assessmentColor}}>
                <div className={fieldData.valueClassName}>{fieldData.value}</div>
            </Col>
            <Col xs={6} lg={2} className="cell region-page-sum-assessment" style={{backgroundColor: fieldData.assessmentColor}}>
                <div className="bigbold">{fieldData.assessment}</div>
                <div>{fieldData.assessmentCaption}</div>
            </Col>
            <Col xs={12} lg={3} className="cell region-page-sum-distribution">
                <div>
                    <div class="d-none d-lg-block">
                        {(props.noDistribution) ?
                                ((props.stateLevelOnly) ? (<div>This data is only available at the state level</div>) : (<div>N/A</div>))
                        : (
                            <DistributionsSection distributions={fieldData.distributions} {...props} />
                        )}
                    </div>
                    <div class="d-xs-block d-lg-none">
                        {(!props.noDistribution) && (
                            <MoreInfoBox toggleText="Distribution" startCollapsed={true}>
                                <DistributionsSection distributions={fieldData.distributions} {...props} />
                            </MoreInfoBox>
                        )  /* else, don't show anything */ }
                    </div>
                </div>
            </Col>
        </Row>
    )
})

let DistributionsSection = (props) => {
    if (props.distributionsComponent) {
        return (
            <props.distributionsComponent distributions={props.distributions} />
        )
    } else {
        return (
            <DistributionsTable distributions={props.distributions}  />
        )
    }
}

let DistributionsTable = (props) => {
    return (
        <Table borderless={true}>
            {
                props.distributions.map(function(d, i) {
                    return <tr><td>{d.title}</td><td style={{textAlign:'right'}}>{d.value}</td></tr>
                })
            }
        </Table>
    )
}
